// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\EnumType.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumItemMD } from '../../../../../../libs/com/MetaPattern/MDA/MD/EnumItemMD';

/**
 * 身份证件枚举 枚举类
 * 身份证件枚举
 */
export enum EnumIdentityDocument {
  /** 身份证 : 身份证 */
  IDCard = 1,
  /** 士官证 : 士官证 */
  Officer = 2,
  /** 护照 : 护照 */
  Passport = 4
}

/**
 * 身份证件枚举 枚举元数据类
 * 获取枚举的元数据信息：名称、显示名称、描述、值
 */
export class EnumIdentityDocumentMD {
  private static items = [
    new EnumItemMD('IDCard', 1, '身份证', '身份证'),
    new EnumItemMD('Officer', 2, '士官证', '士官证'),
    new EnumItemMD('Passport', 4, '护照', '护照')
  ];

  static getItem(enumItem: EnumIdentityDocument) {
    return this.items.find(item => item.name === EnumIdentityDocument[enumItem]);
  }

  static getItemByName(enumItemName: string) {
    return this.items.find(item => item.name === enumItemName);
  }

  static getItemByValue(enumItemValue: number) {
    return this.items.find(item => item.value === enumItemValue);
  }

  static getItems() {
    return this.items;
  }
}
